import { GiftCodePurpose } from '@src/models/giftCodePurpose';

export const giftCodePurposeLabel: Record<GiftCodePurpose, string> = {
  [GiftCodePurpose.GROUP]: '단체용',
  [GiftCodePurpose.PRODUCE]: '판매용',
  [GiftCodePurpose.ETC]: '기타'
};
